import { render, staticRenderFns } from "./ReferenciaPersonalDialogComponent.vue?vue&type=template&id=564f145d&scoped=true"
import script from "./ReferenciaPersonalDialogComponent.vue?vue&type=script&lang=js"
export * from "./ReferenciaPersonalDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ReferenciaPersonalDialogComponent.vue?vue&type=style&index=0&id=564f145d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f145d",
  null
  
)

export default component.exports